import { showMessagePersonalizedPosition } from "services/SweetAlert";

export default class TableData {
    constructor(){
        this.page=0;
        this.lastSearchText="";
        this.lastOrderBy ={"field":"", "direction":""};
        this.promise=null;
        this.query=null;
        this.header=null;
        this.service=null;
        this.dataTable = []
    }

    setQuery(_query){    this.query=_query;       }
    setHeader(_header){  this.header= _header;    }
    setService(_service){  this.service= _service;}

    setPage(){
        this.page=(this.lastSearchText=== this.query.search) ? this.query.page  : 0;
        if (this.query.orderBy!==undefined) {
            if (this.query.orderBy.field!==this.lastOrderBy.field || this.query.orderDirection !== this.lastOrderBy.direction){
                this.page=0;
            }
        }
    }

    setLastOrderBy(){
        if (this.query.orderBy===undefined) this.lastOrderBy={"field":"", "direction":""};
        else                                this.lastOrderBy={"field":this.query.orderBy.field, "direction":this.query.orderDirection};
    }

    setLastSearchText(){    this.lastSearchText= this.query.search;  }

    verificateIfIsDate(value){
        if(typeof value === 'string') {
            const valueSplit = value?.split('/');
            if(valueSplit?.length === 3) {
                // const date = new Date(valueSplit[2], valueSplit[1] - 1, valueSplit[0]);
                // return new Date(`${date.toDateString()} 00: UTC`);
                // return new Date(valueSplit[2], valueSplit[1] - 1, valueSplit[0])
                return value;
            }
        }
        return value;
    }

    setSearchCriteria(){
        this.service.searchCriteria.clear();
        this.service.searchCriteria.setOperator("or");
        let self = this;

        if(this.query?.filters.length > 0 ) {
            this.query.filters.forEach( item => {
                const value = this.verificateIfIsDate(item.value || "");
                self.service.searchCriteria.add(item.column.field, item.searchCriteria || "Contiene", value, item.operatorCriteria || "and" );                
            })
        }

        if (this.query.search.length>0){
            this.header.forEach(function(item) {
                self.service.searchCriteria.addContains(item.field, self.query.search);
            });
        }

        if (this.service.initSearchCriteria!==null){
            this.service.initSearchCriteria.get().forEach(function(item) {
                self.service.searchCriteria.setOperator(item.operator);
                self.service.searchCriteria.add(item.id, item.option, item.value);
            });
        }
    }

    setOrderCriteria(){
        this.service.orderCriteria.clear();
        if (this.query.orderBy!==undefined) this.service.orderCriteria.add(this.query.orderBy.field,  this.query.orderDirection);
        let self = this;
        if (this.service.initOrderCriteria!==null){
            this.service.initOrderCriteria.get().forEach(function(item) {
                self.service.orderCriteria.add(item.id, item.option);
            });
        }

        // console.log("searchCriteria", this.service.initSearchCriteria.get());
    } 

    async setPromise(){
        try{
            let result = await this.service.pageRegister(this.page, this.query.pageSize);
            this.service.searchCriteria.clear();
            this.promise= new Promise((resolve, reject) => {
                if (result.error!==null) {
                    if(result?.error?.errorObject?.message) showMessagePersonalizedPosition('warning', '¡Advertencia! ' ,(result?.error?.errorObject?.message || result?.error?.message), 'center');
                    else if(result?.error?.message) showMessagePersonalizedPosition('warning', '¡Advertencia! ' ,(result?.error?.message), 'center');
                    resolve({ data: [], page: 0, pageSize:0, totalCount: 0});// reject("Error al cargar los datos");
                }
                else if (result.data===null)    resolve({ data: [], page: 0 , pageSize:0, totalCount: 0});
                else {
                    resolve({ data: result?.data?.content, dataAdicional: ((result?.dataAdicional) ? result?.dataAdicional[0] : ''), dataComplementoRenap: result?.dataComplementoRenap, page: result?.data?.number, pageSize: result?.data?.size , totalCount: result?.data?.totalElements});
                };
            });
        }catch(error){
            this.promise= new Promise((resolve, reject) => {
                resolve({ data:[], page: 0 , pageSize:0, totalCount: 0});
            });

        }
    }

    async getPromiseResponse(){
        this.setPage();
        this.setLastOrderBy();
        this.setLastSearchText();
        this.setSearchCriteria();
        this.setOrderCriteria();
        await this.setPromise();
        return (this.promise);
    };
}